module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.occupant.completeName))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagDisplayDetail === 0) ? _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Detail")]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfigClose[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Configuration " + _vm._s(_vm.labelOccupant[_vm.actualLanguage]) + " ID: " + _vm._s(_vm.occupant.occupant_id))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelFirstName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.firstname),
      expression: "occupant.firstname"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.occupant.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelLastName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.lastname),
      expression: "occupant.lastname"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.occupant.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelEmail[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.email),
      expression: "occupant.email"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.occupant.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelMobile[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.mobile_phone_number),
      expression: "occupant.mobile_phone_number"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": "999 999-9999"
    },
    domProps: {
      "value": (_vm.occupant.mobile_phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "mobile_phone_number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantModifications()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSectionUnitAttribution[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayAttributionTable) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.occupant.unit_attributions), function(attribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v("\r\n                                            " + _vm._s(attribution.unit_reference_name) + "\r\n                                          ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (attribution.dateStart),
        callback: function($$v) {
          _vm.$set(attribution, "dateStart", $$v)
        },
        expression: "attribution.dateStart"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (attribution.dateEnd),
        callback: function($$v) {
          _vm.$set(attribution, "dateEnd", $$v)
        },
        expression: "attribution.dateEnd"
      }
    })], 1)])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOccupantAttribution(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.flagAddAttribution) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelUnit[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoUnit),
      expression: "tempoUnit"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempoUnit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.unitList), function(unit) {
    return _c('option', {
      domProps: {
        "value": unit.unit_id
      }
    }, [_vm._v(_vm._s(unit.reference_name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelDateStart[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.tempoUnitDateStart),
      callback: function($$v) {
        _vm.tempoUnitDateStart = $$v
      },
      expression: "tempoUnitDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelDateEnd[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.tempoUnitDateEnd),
      callback: function($$v) {
        _vm.tempoUnitDateEnd = $$v
      },
      expression: "tempoUnitDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default align-right push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantAttribution()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveAttribution[_vm.actualLanguage]))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAddAttribution()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAddAttribution()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAjouterAttribution[_vm.actualLanguage]))])]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSectionFixCosts[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "push-30"
  }, [_vm._v(_vm._s(_vm.labelFixCostExplanation[_vm.actualLanguage]))]), _vm._v(" "), (_vm.occupant.fix_costs.length > 0) ? _c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn06[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.occupant.fix_costs), function(cost, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.yearlyFlag),
        expression: "cost.yearlyFlag"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(cost.yearlyFlag) ? _vm._i(cost.yearlyFlag, null) > -1 : (cost.yearlyFlag)
      },
      on: {
        "change": function($event) {
          var $$a = cost.yearlyFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(cost, "yearlyFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(cost, "yearlyFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(cost, "yearlyFlag", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.description),
        expression: "cost.description"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.cost),
        expression: "cost.cost"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.cost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "cost", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFixCost(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addFixCostLine()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddFixCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantModifications()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, _vm._l((_vm.occupant.options), function(category, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12 push"
    }, [_c('h5', {
      staticClass: "push"
    }, [_vm._v(_vm._s(category.categoryTitle[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((category.options), function(Option, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [(Option.valueType == 'bool') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h5', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(Option.value) ? _vm._i(Option.value, null) > -1 : (Option.value)
        },
        on: {
          "change": function($event) {
            var $$a = Option.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(Option, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(Option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(Option, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span'), (Option.value) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'stringNumber') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control align-center",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (Option.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Option, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'listString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_vm._v("\r\n                                  " + _vm._s(Option) + "\r\n                                ")]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantModifications()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("Section qui affiche le détail du consommateur")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa6d9764","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cost_splitting/OccupantDisplay.vue
// module id = 1592
// module chunks = 4